import {FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import type {Specialty} from 'presentation/utils/categorizeSpecialtiesByFirstLetter';
import {FlowEnumWithoutProfile} from 'presentation/utils';
import {HealthRequestSchedulePermissionType} from 'presentation/modules/booking/shared/hooks/useRequestSchedulePermission/types';

export enum BookingNotFoundStateVariantEnum {
	CITY = 'CITY',
	UF = 'UF',
	SPECIALTY = 'SPECIALTY',
	UNIT = 'UNIT',
	DISTRICT = 'DISTRICT',
	PROFESSIONAL = 'PROFESSIONAL',
	BE_BORN_WELL = 'BE_BORN_WELL',
}

export type BookingNotFoundStateProps = {
	pageTitle?: string;
	handleBack?: () => void;
	variant: BookingNotFoundStateVariantEnum;
	showHeader?: boolean;
	internalPadding?: boolean;
	flowType: FlowEnumWithoutProfile;
	dataTagId?: FinishWithoutCompleteFlowEnum | string;
	healthRequestSchedulePermission?: HealthRequestSchedulePermissionType;
	specialtyNotAvailableOnline?: boolean;
	handleNext?: () => void | undefined;
	selectedSpecialty?: Specialty;
};
